import styled from 'styled-components';
import { Button } from 'junto-ui';

export const Title = styled.h2`
  font-family: Metropolis;
  font-size: 48px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #180a33;
  text-align: left;

  @media (max-width: 767px) {
    font-size: 26px;
  }

  @media (max-width: 767px) {
    line-height: 1.31;
  }
`;

export const MediunTitle = styled.h2`
  font-family: Metropolis;
  font-size: 38px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #180a33;
  text-align: left;

  @media (max-width: 767px) {
    font-size: 26px;
  }

  @media (max-width: 767px) {
    line-height: 1.31;
  }
`;

export const SpanLight = styled.span`
  font-family: Metropolis;
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #180a33;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const SpanVeryLight = styled.span`
  font-family: Metropolis;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #859099;
`;

export const SpanHeavy = styled.span`
  font-family: Metropolis;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #180a33;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const StyledFont = styled.span`
  font-family: Metropolis;
  font-size: 48px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #9000ff;

  @media screen and (max-width: 767px) {
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
`;

export const Section = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ListSection = styled.div`
  margin-top: 9px;
  margin-bottom: 9px;
`;

export const BorderedSection = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  border-top: solid 1px #e0e7ec;
  border-right: solid 1px #e0e7ec;
  border-left: solid 1px #e0e7ec;
  background-color: #ffffff;
`;

export const ButtonLeft = styled(Button)`
  float: left;

  @media (max-width: 767px) {
    float: none;
  }

  @media (max-width: 767px) {
    max-width: initial;
  }
`;

export const CenterButton = styled(Button)`
  @media (max-width: 767px) {
    max-width: initial;
  }
`;
